export default __webpack_public_path__ + "static/media/117t.3f97d747.jpg";